export default "__VITE_ASSET__5211e209__"